import { Autoplay, EffectFlip } from 'swiper';
import { updateLazy } from 'Functions/lazy';


export const indexB2bBannerSliderOptions = (instance, options) => {
    instance.customNavTexts = [...instance.querySelectorAll('[data-custom-nav-text]')].map(el => el.dataset.customNavText)

    return {
        modules: [...options.modules, ...[Autoplay]],
        followFinger: false,
        speed: 500,
        slidesPerView: 1,
        autoplay: {
            delay: 2500,
            disableOnInteraction: true,
            pauseOnMouseEnter: true,
        },
        pagination: {
            el: document.querySelector('.js-index-banner-pagination'),
            bulletClass: 'c-btn--pagination',
            bulletActiveClass: 'is-active',
            renderBullet: function (index, className) {
                const text = instance.customNavTexts[index]
                const number = (index + 1).toString().padStart(2, '0')

                return `
                    <button class="c-btn ${className}" type="button" data-slide-index="${index}">
                        <span class="c-text">
                            <span class="cxs-is-visible xs-is-visible">${number}</span>
                            <span class="cxs-is-hidden xs-is-hidden">${text}</span>
                        </span>
                        <span class="c-text-active">
                            <span class="cxs-is-visible xs-is-visible">${number}</span>
                            <span class="cxs-is-hidden xs-is-hidden">${text}</span>
                        </span>
                    </button>
                    <span class="is-divider"></span>
                `
            }
        },
        on: {
            afterInit(swiper) {
                requestAnimationFrame(() => {
                    for (const button of document.querySelectorAll('.js-index-banner-pagination .c-btn')) {
                        button.addEventListener('click', (event) => {
                            swiper.slideTo(event.currentTarget.dataset.slideIndex)
                        })
                    }
                })
            },
            slideChange(swiper) {
                updateLazy();
            }
        }
    }
}

export const indexB2cBannerSliderOptions = (instance, options) => {
    return {
        modules: [...options.modules, ...[Autoplay]],
        slidesPerView: 1,
        followFinger: false,
        speed: 500,
        loop: false,
        autoplay: {
            delay: 5000,
            pauseOnMouseEnter: true,
            disableOnInteraction: false,
        },
        on: {
            afterInit(swiper) {
                requestAnimationFrame(() => {
                    for (const button of document.querySelectorAll('.js-index-banner-pagination .c-progress-bar--pagination')) {
                        button.addEventListener('click', (event) => {
                            swiper.slideTo(event.currentTarget.dataset.slideIndex)
                        })
                    }
                })
            },
            slideChange(swiper) {
                updateLazy();
            }
        },
        pagination: {
            el: document.querySelector('.js-index-banner-pagination'),
            bulletClass: 'c-progress-bar--pagination',
            bulletActiveClass: 'is-active',

            renderBullet: function (index, className) {
                return `
                    <div class="c-progress-bar ${className}" data-slide-index="${index}">
                        <span class="c-progress-bar__progress"></span>
                    </div>
                `
            }
        },
    }
}

export const listingB2bBannerSliderOptions = (instance, options) => {
    return {
        modules: [...options.modules, ...[Autoplay]],
        followFinger: false,
        speed: 500,
        slidesPerView: 1,
        autoplay: {
            delay: 2500,
            disableOnInteraction: true,
            pauseOnMouseEnter: true,
        }
    }
}

export const listingB2cBannerSliderOptions = (instance, options) => {
    return {
        modules: [...options.modules],
        followFinger: false,
        speed: 500,
        slidesPerView: 1,
        spaceBetween: 0,
        breakpoints: {
            1024: {
                cssMode: false,
                spaceBetween: 14,
                slidesPerView: 2,
            }
        },
    }
}

export const b2bLeafletSliderOptions = (instance, options) => {
    const sliderOptions = {
        modules: [...options.modules],
        autoHeight: false,
        loop: false,
        slidesPerView: 1,
        slidesPerGroup: 1,
        spaceBetween: 0,
        effect: 'slide',
        // Watch for resize and DOM changes
        observer: true,
        observeParents: true,
        resizeObserver: true,
        // Desktop: 2 pages side by side (above 1416px)
        breakpoints: {
            1417: {
                slidesPerView: 2,
                slidesPerGroup: 2,
            }
        },
        on: {
            afterInit(swiper) {
                // Bind external navigation buttons with delay to ensure DOM is ready
                setTimeout(() => {
                    const prevButtons = document.querySelectorAll('.c-leaflet-nav-control--prev, .c-leaflet-floating-nav .swiper-button-prev');
                    const nextButtons = document.querySelectorAll('.c-leaflet-nav-control--next, .c-leaflet-floating-nav .swiper-button-next');

                    console.log('Leaflet nav buttons found:', { prev: prevButtons.length, next: nextButtons.length });

                    prevButtons.forEach(btn => {
                        btn.addEventListener('click', (e) => {
                            e.preventDefault();
                            console.log('Prev clicked, isBeginning:', swiper.isBeginning);
                            swiper.slidePrev();
                        });
                    });

                    nextButtons.forEach(btn => {
                        btn.addEventListener('click', (e) => {
                            e.preventDefault();
                            console.log('Next clicked, isEnd:', swiper.isEnd);
                            swiper.slideNext();
                        });
                    });

                    // Update button states
                    const updateButtonStates = () => {
                        prevButtons.forEach(btn => {
                            btn.classList.toggle('swiper-button-disabled', swiper.isBeginning);
                        });
                        nextButtons.forEach(btn => {
                            btn.classList.toggle('swiper-button-disabled', swiper.isEnd);
                        });
                    };

                    updateButtonStates();
                    swiper.on('slideChange', updateButtonStates);
                }, 100);
            },
            slideChange(swiper) {
                // Dispatch event for Vue component to update currentPage
                // activeIndex is 0-based, so add 1 for display
                const event = new CustomEvent('leaflet-slide-change', {
                    detail: { activeIndex: swiper.activeIndex + 1 }
                });
                document.dispatchEvent(event);
            }
        }
    }

    return sliderOptions
}